/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log( 'destinations block' );
// let tl = gsap.timeline({
// 	// scrollTrigger: {
// 	// 	trigger: ".destinations-list",
// 	// 	start: "top 80%",
// 	// 	end: "bottom 20%",
// 	// 	// markers: true,
// 	// 	toggleActions: "play none none reverse",
// 	// }
// 	delay: 0.1,
// 	fillMode: "backwards"
// });
// tl.fromTo(".destinations-list .destination-item", {y: 50, opacity: 0}, {y: 0, opacity: 1, duration: 1, ease: "back.out", stagger: 0.3});
/* eslint-enable no-console */
